import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { IButtonDirective, IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-asin-selection-wrapper",
  imports: [IButtonDirective, TranslocoDirective, IIconComponent],
  templateUrl: "./asin-selection-wrapper.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsinSelectionWrapperComponent {
  withDelete = input<boolean>(false);
  withMove = input<boolean>(false);
  withEdit = input<boolean>(false);
  withAdd = input<boolean>(false);

  deleteClicked = output<void>();
  moveClicked = output<void>();
  editClicked = output<void>();
  addClicked = output<void>();
}
